import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';

export class PremiumPlusDialogStore {
    rootStore: RootStore;

    opened: boolean = false;

    type: 'auto' | 'click' = 'click';

    period: 'yearly' | 'monthly' = 'yearly';

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    open(type: 'auto' | 'click' = 'click'): void {
        this.opened = true;
        this.rootStore.alertStore.setModalPlacement();
        this.type = type;
    }

    openAfterRouteChange(): void {
        if (this.rootStore.authStore.userHasPremiumTariff) {
            setTimeout(() => {
                if (!this.rootStore.cookieService.hasPremiumPlusDialogOpenProtection()) {
                    this.open('auto');
                    this.rootStore.cookieService.setPremiumPlusDialogOpenProtection(30 * 60);
                }
            }, 2000);
        }
    }

    close(): void {
        this.opened = false;
        this.rootStore.alertStore.setDefaultPlacement();
    }
}
